import Vue from 'vue'
import Vuex from 'vuex'
import newsManagement from './newsManagement'
import formManagement from './formManagement'
import eventManagement from './eventManagement'
import OrganizationalEventsManagement from './OrganizationalEventsManagement'
import bannersManagement from './bannersManagement'
import homeManagement from './homeManagement'
import aboutManagement from './aboutManagement'
import aboutFaq from './aboutFaq'
import infoManagement from './infoManagement'
import invitedToCooperateManagement from './invitedToCooperateManagement'
import authManagement from './authManagement'
import lightBlocksManagement from "./lightBlocksManagement/lightBlocksManagement";
import materialManagement from "./materialManagement/materialManagement";
import glassManagement from "./glassManagement/glassManagement";
import productManagement from "./productManagement/productManagement";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        newsManagement,
        eventManagement,
        OrganizationalEventsManagement,
        bannersManagement,
        formManagement,
        homeManagement,
        aboutManagement,
        aboutFaq,
        infoManagement,
        invitedToCooperateManagement,
        authManagement,
        lightBlocksManagement,
        materialManagement,
        glassManagement,
        productManagement,
    }
})
